import {IDialog} from "../../component/modal/component";
import {global} from "../../appContext";
import pubsub from "../../pubsub";
import {AbstractCrudBase} from "./AbstractItem";
import {createErrorMessage} from "../../util/misc";
import {COPYING_MESSAGE, DELETING_MESSAGE} from "../../constants/Language";
import {ICloneParams} from "../index";
import deleteHtml from './delete.html?raw';

export let template: string = deleteHtml;

export abstract class AbstractDelete extends AbstractCrudBase {

    override readonly Step = {
        INIT: "init",
        PROCESS: "process",
        ERROR: "error"
    };

    protected override readonly STEP_ORDER = [
        this.Step.INIT,
        this.Step.PROCESS,
        this.Step.ERROR,
    ];

    // override these
    private readonly PROCESS_MESSAGE: string = DELETING_MESSAGE;
    private readonly SUCCESS_MESSAGE: string;
    protected abstract readonly EVENT_SUCCESS: string;

    constructor(protected override params: ICloneParams) {
        super(params);
        this.SUCCESS_MESSAGE = `subject is deleted|s:((${params.options.translationKey}))`
        this.step(this.Step.INIT);
    }

    protected override updateStep() {
        switch (this.step()) {
            case this.Step.INIT:
                this.messageData(null);
                break;
            case this.Step.PROCESS:
                this.messageData({message: this.PROCESS_MESSAGE});
                this.params.dialog.closeable(false);
                this.process()
                    .then(this.processSuccess.bind(this))
                    .catch(this.processError.bind(this));
                break;
            case this.Step.ERROR:
                this.params.dialog.closeable(true);
                break;
        }
    }

    protected override processSuccess(data: any[]) {
        global.snackbarData({message: this.SUCCESS_MESSAGE});
        pubsub.trigger(this.EVENT_SUCCESS);
        pubsub.trigger("close.dialog", this.params.dialog);
    }

    protected override processError(reason: string) {
        this.step(this.Step.ERROR);
        this.messageData(createErrorMessage(String(reason)));
    }

    protected getName(): string {
        return this.params.item.name;
    }

}